import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cree-devis-negoce',
  templateUrl: './cree-devis-negoce.component.html',
  styleUrls: ['./cree-devis-negoce.component.scss']
})
export class CreeDevisNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
